<div class="title-page-container">
    <div class="title-page-center-el">
        <div class="title-page-title ">
            <div class="title-page-icon">
                <img [src]="newImg" alt="img">
            </div>
            Карта памятных мест
        </div>
        <div class="title-page-subtitle">
            <div>
                Проект Северной железной дороги – филиала ОАО «РЖД»,
            </div>
            <div>
                призванный увековечить память о подвиге железнодорожников
            </div>
            <div>
                в годы Великой Отечественной войны.
            </div>
        </div>
    </div>
</div>
<div class="title-page-title-mob">
    <div class="title-mob-container">
        <div class="col-8">
            <div class="title-page-mob-title">
                Карта памятных мест
            </div>
            <div class="title-page-mob-subtitle">
                Проект Северной железной дороги – филиала ОАО «РЖД»,
                призванный увековечить память о подвиге железнодорожников
                в годы Великой Отечественной войны.
            </div>
        </div>
    </div>
</div>
